export default __webpack_public_path__ + "82c67a72c81266b6d8bfedbb070f54fa.svg";